import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import TypoFramed from '../../components/TypoFramed';
import { ReactComponent as Play } from '../../res/play.svg';
import { ReactComponent as Add } from '../../res/add.svg';
import ButtonWithIcon from '../../components/ButtonWithIcon';
import PopupInterview from '../../popups/PopupInterview';
import PopupTemplate01 from '../../popups/PopupTemplate01';

import styles from './styles';

class B02editos extends React.Component {
  renderContent() {
    const { classes, blockData, frame, baseUrl, onPopup } = this.props;
    const title = parse(blockData.title);
    const subtitle = parse(blockData.subtitle);
    const desc = parse(blockData.desc);
    const buttonText = parse(blockData.buttonText);
    const imgSrc = `${baseUrl}/blocks/${blockData.imgSrc}`;
    const popupTrigger = parse(blockData.popupTrigger);
    const popupItvTrigger = parse(blockData.popupItvTrigger);
    return (
      <div className={classes.content}>
        <div className={classes.main}>
          <div className={classes.column}>
            <Typography variant="h2" className={`${classes.title} `}>
              {title}
            </Typography>
            <TypoFramed variant="body2" frame={frame}>
              {subtitle}
            </TypoFramed>
            <Typography variant="body2" color="secondary" className={classes.desc}>
              {desc}
            </Typography>
            <ButtonWithIcon
              icon={<Add />}
              color="white"
              iconPosition="center"
              className={classes.button}
              onClick={() => onPopup(popupTrigger, true)}
            >
              {buttonText}
            </ButtonWithIcon>
          </div>
          <div className={classes.wrapperPlayer}>
            <img
              key="img"
              role="presentation"
              src={imgSrc}
              alt=""
              onClick={() => onPopup(popupItvTrigger, true)}
              className={classes.image}
            />
            <Play className={classes.playIcon} />
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { classes, blockData, popupData, popupItvData, baseUrl, popupsState, onPopup, color } = this.props;
    const baseUrlBlock = `${baseUrl}/blocks/`;
    const popupTrigger = parse(blockData.popupTrigger);
    const popupItvTrigger = parse(blockData.popupItvTrigger);
    return (
      <div
        style={{ backgroundImage: `url(${baseUrlBlock}${blockData.bg})` }}
        className={`${classes.blockContainer} ${classes[color]}`}
      >
        {this.renderContent()}
        <PopupTemplate01
          popupData={popupData}
          open={!!popupsState[popupTrigger]}
          baseUrl={baseUrl}
          color={popupData.color}
          onClose={() => onPopup(popupTrigger, false)}
        ></PopupTemplate01>
        <PopupInterview
          baseUrl={baseUrl}
          interview={popupItvData}
          open={!!popupsState[popupItvTrigger]}
          onClose={() => onPopup(popupItvTrigger, false)}
        ></PopupInterview>
      </div>
    );
  }
}

B02editos.propTypes = {
  classes: PropTypes.object.isRequired,
  color: PropTypes.string,
  frame: PropTypes.string,
  blockData: PropTypes.object.isRequired,
  popupData: PropTypes.object.isRequired,
  popupItvData: PropTypes.object.isRequired,
  baseUrl: PropTypes.string,
  popupsState: PropTypes.object,
  onPopup: PropTypes.func,
};

B02editos.defaultProps = {
  frame: 'black',
};

export default withStyles(styles)(B02editos);
